import { render } from "./NotificationAddComponent.vue?vue&type=template&id=0e92fc5a&scoped=true"
import script from "./NotificationAddComponent.vue?vue&type=script&lang=js"
export * from "./NotificationAddComponent.vue?vue&type=script&lang=js"

import "./NotificationAddComponent.vue?vue&type=style&index=0&id=0e92fc5a&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e92fc5a"]])

export default __exports__